(function() {
    'use strict';
    angular.module('app').
    controller('PostcodeProfileController', PostcodeProfileController);

    PostcodeProfileController.$inject = [
        '$location', 
        'Carrier', 
        '$q', 
        'toastr', 
        '$routeParams', 
        'CarrierProfileZonesTableService',
        'Location', 
        'zonePostcodeTableService',
        '$timeout',
        'aborter', 
        'hasDuplicate',
        'ConfirmationModalFactory'
    ];

    function PostcodeProfileController(
        $location, 
        Carrier, 
        $q, 
        toastr, 
        $routeParams, 
        CarrierProfileZonesTableService, 
        Location, 
        zonePostcodeTableService,
        $timeout, 
        aborter, 
        hasDuplicate,
        ConfirmationModalFactory
    ) {
        var vm = this;
        vm.id = $routeParams.id;
        vm.zoneId = $routeParams.zoneId;
        vm.zoneTable = null;
        vm.isInvalid = isInvalid;
        vm.searchForZipcode = searchForZipcode;
        vm.onPostcodeSelect = onPostcodeSelect;
        vm.addToList = addToList;
        vm.createZone = createZone;
        vm.hasDuplicateCode = false;
        vm.hasDuplicateName = false;
        vm.checkNameForDups = checkNameForDups;
        vm.checkCodeForDups = checkCodeForDups;
        vm.alternativeSuburbs = [];
        vm.carrier = {
            zoneDetails : {}
        };
        let abort = null;

        (()=>{
            if (vm.id) {
                vm.isFetching = true;
                const q = {carrierProfile: getCarrierProfile(), zone: getZone(vm.id, vm.zoneId)};
                $q.all(q).then(data => {
                    if(!data.carrierProfile.owned){
                        $location.url('/');
                        return false;
                    }
                    vm.carrier = angular.extend(vm.carrier, data.carrierProfile);
                    vm.carrierRaw = angular.copy(vm.carrier);
                    vm.isFetching = false;
                    Location.Country({
                        // name: model
                    }, function (countries) {
                        vm.countries = countries;
                        vm.zoneTable = new CarrierProfileZonesTableService(vm.id, countries, angular.extend(vm.carrier,{
                            zoneDetails: data.zone || {}
                        })).tableData;
                    }, function (err) {

                    });
                });

                vm.isViewMode = true;
            }else{
                vm.carrierRaw = angular.copy(vm.carrier);
            }
        })();
        function isInvalid(form, name) {
            if(form && form[name])
                return (form[name].$invalid && form.$submitted) || (form[name].$invalid && form[name].$touched);
        }
        function searchForZipcode(model, size) {
            vm.postcodes = [];
            vm.postcodeSearching =true;
            if(abort){
                $timeout.cancel(abort);
                abort = null;
            }
            abort = $timeout(()=>{
                Location.ZipCode({
                    country: angular.getObjVal(vm, 'carrier.zoneDetails.country.code'),
                    size: size,
                    sort: 'code',
                    code: model
                }, data => {
                    function buildStates(codes) {
                        var distinctCodes = [];
                        angular.forEach(codes, function (code, key) {

                            if (codes[key - 1] && code.code == codes[key - 1].code) {
                                distinctCodes[distinctCodes.length - 1].altSuburbs.push(angular.copy(code));
                            } else {
                                code.altSuburbs = [angular.copy(code)];
                                distinctCodes.push(angular.copy(code));
                            }
                        });
                        return distinctCodes;
                    }
                    vm.postcodeSearching = false;
                    angular.forEach(buildStates(data.content), postcode=>vm.postcodes.push(postcode));
                    abort = null;
                }, error=>{
                    abort = null;
                    console.log(error);
                });
            },500);
        }
        function onPostcodeSelect(selected) {
            vm.alternativeSuburbs = selected.altSuburbs;
        }

        function addToList(postcode, form) {
            form.$setSubmitted();
            if(form.$invalid){
                return false;
            }
            vm.saveInprogress = true;
            vm.postcode = null;
            Carrier.addZonePostcode({
                    carrierProfileId: vm.id,
                    zoneId: vm.carrier.zoneDetails.id
                },
                [postcode.id], 
                (data) => {
                    vm.carrier.zoneDetails.postcodesTable = null;
                    $timeout(()=>{
                        vm.carrier.zoneDetails.postcodesTable = new zonePostcodeTableService(
                            angular.extend(vm.carrier.zoneDetails,{newZone:false}), vm.id).tableData;
                    });
                    form.$setPristine();
                    form.$setUntouched();
                    vm.saveInprogress = false
                },
                error => {
                    toastr.error(error.code, error.message);
                    vm.saveInprogress = false;
                });
            /*vm.carrier.zoneDetails.postcodesTable.data.unshift(angular.extend(postcode,{
                postcode: postcode.code || 'N/A',
                postcodeName: postcode.name || 'N/A',
                stateName: angular.getObjVal(postcode, 'state.name') || 'N/A'
            }));*/
        }
        function createZone(form) {
            form.$setSubmitted();
            if(form.$invalid){
                return false;
            }
            Carrier.addZoneProfile(vm.id, cleanZoneProfilePayload(vm.carrier.zoneDetails),
                data=>{
                    angular.extend(vm.carrier.zoneDetails, data);
                    vm.carrier.zoneDetails.postcodesTable = null;
                    $timeout(()=>{
                        vm.carrier.zoneDetails.postcodesTable =
                            new zonePostcodeTableService(angular.extend(vm.carrier.zoneDetails,{newZone: true}), vm.id).tableData;
                        toastr.success('Zone successfully created', 'Success');
                    });
                },error=>{
                    toastr.error('Unable to create zone profile', error.message);
                })
        }
        function checkCodeForDups(model) {
            if(model.length < 3){
                return;
            }
            vm.checkingDups = true;
            aborter(()=>{
                hasDuplicate({
                    serviceCallback: Carrier.getZonePostcodeFileDetail,
                    callbackFormat: ['id', 'success', 'error', 'filter'],
                    findBy: 'content',
                    compareWith: model,
                    compareBy: 'code',
                    raw: angular.getObjVal(vm, 'carrierRaw.zoneDetails.code'),
                    filters: {
                        size: 1,
                        code: model
                    },
                    id: vm.id
                }).then(res=>{
                    if(res)
                        vm.hasDuplicateCode = 'Code already exist';
                    else
                        vm.hasDuplicateCode = null;
                    vm.checkingDups = false;
                }).catch(err=>{
                    vm.checkingDups = false;
                });
            },500);
        }
        function checkNameForDups(model) {
            vm.checkingDups = true;
            aborter(()=>{
                hasDuplicate({
                    serviceCallback: Carrier.getZonePostcodeFileDetail,
                    callbackFormat: ['id', 'success', 'error', 'filter'],
                    findBy: 'content',
                    compareWith: model,
                    compareBy: 'name',
                    raw: angular.getObjVal(vm, 'carrierRaw.zoneDetails.name'),
                    filters: {
                        size: 1,
                        name: model
                    },
                    id: vm.id
                }).then(res=>{
                    if(res)
                        vm.hasDuplicateName = 'Name already exist';
                    else
                        vm.hasDuplicateName = null;
                    vm.checkingDups = false;
                }).catch(err=>{
                    vm.checkingDups = false;
                });
            },500);
        }
        function cleanZoneProfilePayload(data) {
            return {
                code: data.code,
                name: data.name,
                countryId: data.country.id,
                allPostcodesEnabled: !!data.allPostcodesEnabled
            }
        }
        function getCarrierProfile() {
            const defer = $q.defer();
            Carrier.getExternalCarrierProfile(vm.id,
                (data) => defer.resolve(data),
                (error) => defer.reject(error));
            return defer.promise;
        }

        function getZone(carrierProfileId, zoneId) {
            const defer = $q.defer();
            if(!zoneId){
                $timeout(()=>defer.resolve(null))
            }
            Carrier.getZonePostcodeFileDetail(carrierProfileId, data=>{
                defer.resolve(data.content[0]);
            }, error=>{
                toastr.error('Unable to get zone', error.message);
                defer.resolve(null)
            }, {
                id: zoneId
            });
            return defer.promise;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/carriers/CarriersPostcodeProfile.js